export default {
  methods: {
    convert(monthNumbers = [], outFormat = 'MMMM', separator = 'to') {
      const months = this.getContinuousMonthRange(monthNumbers);
      const out = months.map((month) => {
        if (month && month.length > 1) {
          return (
            moment()
              .month(month[0] - 1)
              .format(outFormat) +
            ` ${separator} ` +
            moment()
              .month(month[month.length - 1] - 1)
              .format(outFormat)
          );
        } else {
          return moment()
            .month(month - 1)
            .format(outFormat);
        }
      }) || [];
      return out.join(", ")
    },
    getContinuousMonthRange(months) {
      var ranges = [];
      var subrange = [];

      for (let i = 0; i < 12; ++i) {
        if (typeof months[i] === "undefined") {
          break;
        }

        if (months[i + 1] === months[i] + 1) {
          subrange.push(months[i]);
        } else {
          subrange.push(months[i]);
          ranges.push(subrange);
          subrange = [];
        }
      }

      const firstOfAll = ranges[0][0];
      const lastOfAll =
        ranges[ranges.length - 1][ranges[ranges.length - 1].length - 1];
      if (firstOfAll === 1 && lastOfAll === 12) {
        ranges[0] = ranges[ranges.length - 1].concat(ranges[0]);
        delete ranges[ranges.length - 1];
      }

      return ranges.filter((r) => r);
    },
  },
}